<div class="field">
  <label *ngIf="label" [ngClass]="{ 'required-field': required }">{{ label }}</label>
  <p-dropdown
    [options]="timezones"
    [(ngModel)]="value"
    [disabled]="isDisabled || disabled"
    [placeholder]="placeholder"
    [showClear]="showClear"
    [styleClass]="styleClass"
    optionLabel="label"
    optionValue="value"
    (onChange)="onSelectionChange($event)"
  >
  </p-dropdown>
</div>
